export function getStatsWbtRoutes() {
  return [
    {
      path: "/stats/wbt",
      name: "wbt",
      component: () => import(/* webpackChunkName: stats-wbt-old-backend */ "./components/StatsWbtOld.vue"),
    },
  ]
}
